import EventCalendar from "./calendar";

export default EventCalendar;